export default __webpack_public_path__ + "static/media/markhamCollege.eefc2347.png";